import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ECharts from 'vue-echarts';
// eslint-disable-next-line no-unused-vars
import * as echarts from 'echarts';
Vue.config.productionTip = false
Vue.use(Antd);
Vue.component('v-chart', ECharts);
new Vue({
  render: h => h(App),
}).$mount('#app')
